module.exports = __webpack_public_path__ + "img/search.379e56eb.svg";